import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import VideoTutorial from './components/VideoTutorial';
import StorytellingSlider from './components/StorytellingSlider';
import ProofSection from './components/ProofSection';
import FeedbackSlider from './components/FeedbackSlider';
import PainPoints from './components/PainPoints';
import SystemFeatures from './components/SystemFeatures';
import Testimonials from './components/Testimonials';
import Comparison from './components/Comparison';
import CTASection from './components/CTASection';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import SocialProofPopup from './components/SocialProofPopup';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <VideoTutorial />
      <StorytellingSlider />
      <Stats />
      <ProofSection />
      <FeedbackSlider />
      <PainPoints />
      <SystemFeatures />
      <Testimonials />
      <Comparison />
      <CTASection />
      <FAQ />
      <Footer />
      <SocialProofPopup />
      <Toaster />
    </div>
  );
}

export default App;